import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs/Rx';
import { SelectItem } from 'primeng/primeng';

import { LocalStorageProvider } from 'app/shared/storage-provider/local-storage-provider';
import { LANGUAGE } from './languages.const';

@Injectable()
export class LanguageService {

  public onLanguageChange: Observable<LANGUAGE>;

  private onLanguageChangeSubject: Subject<LANGUAGE> = new Subject();
  private LANGUAGE_STORAGE_KEY: string = 'language';

  constructor(
    private storage: LocalStorageProvider,
    private translate: TranslateService
  ) {
    this.onLanguageChange = this.onLanguageChangeSubject.asObservable();

    this.readQueryLanguage();

    translate.setDefaultLang(LANGUAGE.PL.code);
    this.setLanguage(this.getLanguage());
  }

  public setLanguage(language: LANGUAGE): void {
    this.storage.set(this.LANGUAGE_STORAGE_KEY, language.code);
    this.translate.use(language.code);
    this.onLanguageChangeSubject.next(language);
  }

  public getLanguage(): LANGUAGE {
    const storedLanguageCode: string = this.storage.get(this.LANGUAGE_STORAGE_KEY);

    for (const languageKey in LANGUAGE) {
      if (!LANGUAGE.hasOwnProperty(languageKey)) {
        continue;
      }

      const language: LANGUAGE = LANGUAGE[languageKey];

      if (storedLanguageCode === language.code) {
        return language;
      }
    }

    return LANGUAGE.PL
  }

  public getLanguageOptions(includePlaceholder: boolean = false): SelectItem[] {
    const languageOptions: SelectItem[] = Object.keys(LANGUAGE)
      .map((key: string): SelectItem => {
        return {
          label: this.translate.instant('languages.' + key.toLowerCase()),
          value: LANGUAGE[key].code
        };
      });

    if (includePlaceholder) {
      languageOptions.unshift({
        label: this.translate.instant('languages.choose_language'),
        value: ''
      });
    }

    return languageOptions;
  }

  private readQueryLanguage(): void {
    const queryLang = location.search.match(/language=([a-z_-]+)(&|$)/i);

    if (queryLang) {
      this.storage.set(this.LANGUAGE_STORAGE_KEY, queryLang[1]);
    }
  }
}



// WEBPACK FOOTER //
// /dist/src/app/language/language.service.ts